
import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import { formatDateTime, formatDuration, WindowType } from "../../../../util";
import { Card, CardDuration } from "../../../backend/backendapi";
import { KanbanState } from "../../kanban.model";

declare var window: WindowType;

@Component({
  name: 'DurationInfoModal',
  components: { vSelect }
})
export default class DurationInfoModal extends Vue {
  @Prop({ required: true })
  state!: KanbanState;
  @Prop({ required: true })
  card!: Card;

  userId: string = '';
  
  get entries(): CardDuration[] {
    return (this.card.durations ?? [])
        .filter(e => e.userId === this.userId)
        .sort((l,r) => (r.timeStmp?.getTime() ?? 0) - (l.timeStmp?.getTime() ?? 0)) // sort desc
        .slice(0, 5)
        .reverse();
  }

  formatDateTime = formatDateTime;
  formatDuration = formatDuration;
  
  open(): void {
    this.userId = window.application.kanban.user?.id ?? '';
    $(this.$refs.modal!).modal('show');
  }

  dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
